import { useRef, useEffect } from 'react';

function usePrevious(value) {
  // ref: https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
  const ref = useRef();
  useEffect(
    () => {
      ref.current = value; // assign the value of ref to the argument
    },
    [value],
  ); // this code will run when the value of 'value' changes
  return ref.current; // in the end, return the current ref value.
}

export default usePrevious;
